var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u8-clickable" }, [
    _vm.state === 1
      ? _c("span", [_vm._v(" " + _vm._s(_vm.currCount) + "秒 ")])
      : _vm._e(),
    _vm.state === 0
      ? _c("span", { on: { click: _vm.countDown } }, [_vm._v("发送")])
      : _vm._e(),
    _vm.state === 2
      ? _c("span", { on: { click: _vm.countDown } }, [_vm._v("重新发送")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }